

import React, { useState } from "react";
import { Modal, Button } from "antd";
import styles from "./CustomCalculator.module.css";

const CustomCalculator= () => {
  const [input, setInput] = useState("");
  const [result, setResult] = useState("");

  
const handleClick = (value) => {
  if (value === "=") {
    try {
      let expression = input;

      // Replace operator + percentage pattern (e.g., 90-10%)
      expression = expression.replace(
        /(\d+(\.\d+)?)([+\-×÷])(\d+(\.\d+)?)%/g,
        (match, num1, _, operator, num2) => {
          const n1 = parseFloat(num1);
          const n2 = parseFloat(num2);
          switch (operator) {
            case "+":
              return `${n1}+(${n1}*${n2}/100)`;
            case "-":
              return `${n1}-(${n1}*${n2}/100)`;
            case "×":
            case "*":
              return `${n1}*(${n2}/100)`;
            case "÷":
            case "/":
              return `${n1}/(${n2}/100)`;
            default:
              return match;
          }
        }
      );

      // Handle standalone percentages (like "10%")
      expression = expression.replace(/(\d+(\.\d+)?)%/g, "($1/100)");

      // Replace calculator symbols × ÷ − with JS equivalents
      expression = expression
        .replace(/×/g, "*")
        .replace(/÷/g, "/")
        .replace(/−/g, "-");

      const resultValue = eval(expression);
      setResult(resultValue.toString());
    } catch {
      setResult("Error");
    }
  } else if (value === "C") {
    setInput("");
    setResult("");
  } else if (value === "CE") {
    setInput(input.slice(0, -1));
  } else {
    // ✅ Replace comma with point for decimals
    const newValue = value === "," ? "." : value;
    setInput(input + newValue);
  }
};
  const buttons = [
    ["CE", "C", "%", "÷"],
    ["7", "8", "9", "×"],
    ["4", "5", "6", "−"],
    ["1", "2", "3", "+"],
    ["±", "0", ".", "="],
  ];

  return (
    <>
        <div className={styles.calculator}>
          <div className={styles.display}>
            <div className={styles.input}>{input}</div>
            <div className={styles.result}>{result}</div>
          </div>

          <div className={styles.buttons}>
            {buttons.flat().map((btn, idx) => (
              <button
                key={idx}
                className={`${styles.button} ${
                  ["÷", "×", "−", "+", "="].includes(btn)
                    ? styles.operator
                    : btn === "CE"
                    ? styles.clear
                    : ""
                }`}
                onClick={() => handleClick(
                  btn === "×"
                    ? "*"
                    : btn === "÷"
                    ? "/"
                    : btn === "−"
                    ? "-"
                    : btn
                )}
              >
                {btn}
              </button>
            ))}
          </div>
        </div>
    </>
  );
};

export default CustomCalculator;
